import eoKajInternet from './eoKajInternet';
import eoLingvaFenomeno from './eoLingvaFenomeno';
import interkonsento from './interkonsento';
import my_szhigaem_svoi_zhizni from '../rezonadoj/my_szhigaem_svoi_zhizni';
import vesna_2020_2 from './vesna_2020_2';
import o_knizhnyh_liydyah from './o_knizhnyh_liydyah';
import o_poliglotah from './o_poliglotah';
import ehala_naudachu from './ehala_naudachu';

const list = [
  eoKajInternet,
  eoLingvaFenomeno,
  interkonsento,
  my_szhigaem_svoi_zhizni,
  vesna_2020_2,
  o_knizhnyh_liydyah,
  o_poliglotah,
  ehala_naudachu
];

export default list;